<template>
  <v-list-tile :key="entity.id">
    <v-list-tile-action v-if="addSelectCheckbox">
      <v-checkbox v-model="entity.selected"></v-checkbox>
    </v-list-tile-action>
    <v-list-tile-avatar mr-2>
      <file-icon-status
        :badge-color="getBadgeColor()"
        file-hover-color="primary"
        :status="getFileStatus()"
        @click="downloadEntity(entity)"
      ></file-icon-status>
    </v-list-tile-avatar>
    <v-list-tile-content>
      <v-list-tile-title
        v-for="field in levelZero"
        :key="field.name"
        v-html="$t(entity[field.name])"
      ></v-list-tile-title>
      <v-list-tile-sub-title v-if="displayLevel >= 1">
        <v-layout row wrap>
          <v-flex v-for="field in levelOne" :key="field.name" class="text-sm-left" xs3>
            <b v-if="field.showLabel">{{ $t(field.label) }}:</b>
            <template v-if="Array.isArray(entity[field.name])">
              <span v-for="(value, v) in entity[field.name]" :key="v">
                {{ $t(value[field.primaryField]) | truncate(20, '...') }}
              </span>
            </template>
            <template v-else-if="field.type && field.type === 'object'">
              <span v-if="field.fieldValue && entity[field.name]">
                {{ $t(entity[field.name][field.fieldValue]) | truncate(20, '...') }}
              </span>
            </template>
            <template v-else>
              <span v-if="field.name === 'created_at'">
                {{ $t(entity[field.name]) | moment('DD/MM/YYYY') }}
              </span>
              <span v-else>{{ $t(entity[field.name]) }}</span>
            </template>
          </v-flex>
        </v-layout>
      </v-list-tile-sub-title>
      <v-list-tile-sub-title v-if="displayLevel >= 2">
        <span v-for="field in levelTwo" class="mr-2" :key="field.name">
          <b v-if="field.showLabel">{{ $t(field.label) }}:</b>
          {{ $t(entity[field.name]) | truncate(20, '...') }}
        </span>
      </v-list-tile-sub-title>
    </v-list-tile-content>
    <v-list-tile-action>
      <template v-if="adminActions">
        <v-menu>
          <v-btn slot="activator" color="primary" dark flat min-width="100">
            {{ $t('Acciones') }}
          </v-btn>
          <v-list>
            <v-list-tile @click="changeStatus('contabilized')">
              <v-list-tile-title>
                {{ $t('Contabilizado') }}
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="changeStatus('in_process')">
              <v-list-tile-title>
                {{ $t('En proceso') }}
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="changeStatus('error')">
              <v-list-tile-title>
                {{ $t('Con errores') }}
              </v-list-tile-title>
            </v-list-tile>

            <v-list-tile @click="changeStatus('uncontabilized')">
              <v-list-tile-title>
                {{ $t('Sin contabilizar') }}
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="deleteDocument(entity)">
              <v-list-tile-title class="error--text">
                {{ $t('Eliminar') }}
              </v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </template>
    </v-list-tile-action>
    <v-list-tile-action v-if="!adminActions" class="ml-2">
      <v-btn flat color="primary" dark @click="downloadEntity(entity)">
        <v-icon color="primary">mdi-download</v-icon>
        {{ $t('Descargar') }}
      </v-btn>
      <v-btn
        v-if="entity.status === 'uncontabilized'"
        @click="deleteDocument(entity)"
        color="red"
        flat
        dark
        min-width="100"
      >
        <v-icon color="error">mdi-trash-can-outline</v-icon>
        {{ $t('Eliminar') }}
      </v-btn>
    </v-list-tile-action>
  </v-list-tile>
</template>

<script>
import AruListItemMixin from '@/mixins/list/AruListItemMixin.js';
import FileIconStatus from '@/components/commons/FileIconStatus.vue';
import apiCtrl from '@/services/api/abstract/abstract-api.js';
// const moment = require('moment')
// require('moment/locale/es')
export default {
  mixins: [AruListItemMixin],
  props: {
    adminActions: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    FileIconStatus,
  },
  methods: {
    getFileStatus() {
      switch (this.entity.status) {
        case 'uncontabilized':
          return 'in-process';
        case 'contabilized':
          return 'finish';
        case 'error':
          return 'error';
        default:
          return this.entity.status;
      }
    },
    getBadgeColor() {
      switch (this.entity.status) {
        case 'uncontabilized':
          return 'grey lighten-1';
        case 'contabilized':
          return 'primary';
        case 'in_process':
          return 'secondary';
        case 'error':
          return 'error';
        default:
          return 'grey lighten-1';
      }
    },
    downloadEntity(entity) {
      console.log(entity);
      if (entity.hasOwnProperty('media') && entity.media.length > 0) {
        apiCtrl
          .get('/document/download/' + entity.media[0].id + '?document=' + entity.id)
          .then(res => {
            this.$emit('inProcessItem', entity.id);
            apiCtrl.downloadFile(res.data);
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    deleteDocument(entity) {
      this.$emit('deleteItem', entity);
    },
    changeStatus(status) {
      apiCtrl.post('/document/change-status/' + this.entity.id, { status: status }).then(res => {
        console.log({ DOCUMENTO: res });
        this.entity.status = status;
      });
    },
  },
};
</script>

<style></style>
